import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

//import theme from '@ecp/common/src/style/theme/default';
import { FlexBox, FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { TextBox } from '@ecp/common/src/text/TextBox';
import Dropdown from '@ecp/common/src/components/dropdown/Dropdown';

import GoodOptionItem from '@fo-pages/good/summary/option/GoodOptionItem';
import { useTheme } from 'styled-components';

const SubGoodOptionItem = ({ itemList, subGoodIndex, soldOut, stopSale, ...props }) => {
  const leafItem = useMemo(
    () => (itemList[0]?.itemNumber === '00000' ? { ...itemList[0], soldOut, stopSale } : undefined),
    [itemList, soldOut, stopSale]
  );

  return <GoodOptionItem leafItem={leafItem} subGoodIndex={subGoodIndex} {...props} />;
};

SubGoodOptionItem.propTypes = {
  label: PropTypes.string,
  subGoodIndex: PropTypes.string,
  itemList: PropTypes.array,
  stockManagement: PropTypes.bool,
  disabled: PropTypes.bool,
  soldOut: PropTypes.bool,
  stopSale: PropTypes.bool,
};

const GoodOptionGroup = ({ floatingType, subGoodItemList, subGoodDetail, onSelect }) => {
  const theme = useTheme();
  return (
    <FlexBoxColumn gap={'10px'} width={'100%'}>
      <FlexBox width={'100%'}>
        {!floatingType && (
          <TextBox flex={'1'} weight={theme.font.weight.medium}>
            상품
          </TextBox>
        )}
        <FlexBox flex={'4'} width={floatingType ? '300px' : '480px'}>
          <Dropdown
            placeholder={'상품을 선택해 주세요'}
            itemsMaxHeight={'200px'}
            items={subGoodItemList}
            value={subGoodDetail}
            onChange={onSelect}
            itemSlot={SubGoodOptionItem}
          />
        </FlexBox>
      </FlexBox>
    </FlexBoxColumn>
  );
};

GoodOptionGroup.propTypes = {
  floatingType: PropTypes.bool,
  subGoodItemList: PropTypes.array,
  subGoodDetail: PropTypes.object,
  onSelect: PropTypes.func,
};

export default GoodOptionGroup;
